import React, { useState, useCallback } from 'react';
import type { CategoryFormData, CategoryFormLabels, CategoryFormProps } from '../../shared/types/categoryForm';

export type { CategoryFormData, CategoryFormLabels, CategoryFormProps };

export function CategoryForm({
  initialData,
  onSubmit,
  onCancel,
  errors = {},
  labels: l,
  mode,
}: CategoryFormProps) {
  const [formData, setFormData] = useState<CategoryFormData>(initialData);

  const handleChange = useCallback((value: string) => {
    setFormData(prev => ({ ...prev, name: value }));
  }, []);

  const handleSubmit = useCallback((e: React.FormEvent) => {
    e.preventDefault();
    onSubmit(formData);
  }, [formData, onSubmit]);

  return (
    <form onSubmit={handleSubmit}>
      {/* Error messages */}
      {Object.keys(errors).length > 0 && (
        <div className="alert alert-danger mb-3">
          <ul className="mb-0">
            {Object.entries(errors).flatMap(([field, messages]) =>
              messages.map((msg, i) => (
                <li key={`${field}-${i}`}>{msg}</li>
              ))
            )}
          </ul>
        </div>
      )}

      {/* Name field */}
      <div className="form-group row my-3">
        <div className="col-12">
          <div className="form-floating">
            <input
              type="text"
              className="form-control"
              id="category-name"
              value={formData.name}
              onChange={(e) => handleChange(e.target.value)}
              required
              autoFocus={mode === 'new'}
              placeholder={l.name}
            />
            <label htmlFor="category-name" className="form-label">{l.name}</label>
          </div>
        </div>
      </div>

      {/* Form Buttons */}
      <div className="form-group d-flex justify-content-end buttons-wrapper">
        <button
          type="button"
          className="btn btn-link me-3"
          onClick={onCancel}
        >
          {l.cancel}
        </button>
        <button
          type="submit"
          className="btn btn-primary"
          data-test-id="save-button"
        >
          {l.save}
        </button>
      </div>
    </form>
  );
}

export default CategoryForm;
